/* eslint-disable quotes */
export const notFoundTranslations = {
  'en-GB': {
    notFound: {
      meta: {
        title: 'Coming soon – Colozoo',
        description:
          'This Colozoo page is not available yet. Return to the homepage or contact support if you need help.',
      },
      titleLead: 'This page is',
      titleAccent: 'not ready yet',
      body1:
        'Thank you for visiting Colozoo. We are still preparing the content for this page.',
      body2:
        'You can go back to the homepage, or email us if you need help with a product you already have.',
      goHome: 'Go to homepage',
      askQuestion: 'Contact us',
      contactLabel: 'Questions about a product?',
      contactLink: 'Email Colozoo support',
    },
  },
  'en-US': {
    notFound: {
      meta: {
        title: 'Coming soon – Colozoo',
        description:
          'This Colozoo page is not available yet. Return to the homepage or contact support if you need help.',
      },
      titleLead: 'This page is',
      titleAccent: 'not ready yet',
      body1:
        'Thank you for visiting Colozoo. We are still preparing the content for this page.',
      body2:
        'You can go back to the homepage, or email us if you need help with a product you already have.',
      goHome: 'Go to homepage',
      askQuestion: 'Contact us',
      contactLabel: 'Questions about a product?',
      contactLink: 'Email Colozoo support',
    },
  },
  de: {
    notFound: {
      meta: {
        title: 'Demnächst – Colozoo',
        description:
          'Diese Colozoo-Seite ist noch nicht verfügbar. Zur Startseite oder per E-Mail an den Support.',
      },
      titleLead: 'Diese Seite ist',
      titleAccent: 'noch nicht fertig',
      body1:
        'Danke für Ihren Besuch bei Colozoo. Die Inhalte für diese Seite bereiten wir derzeit noch vor.',
      body2:
        'Zurück zur Startseite — oder schreiben Sie uns, wenn Sie Hilfe zu einem Produkt brauchen.',
      goHome: 'Zur Startseite',
      askQuestion: 'Kontakt',
      contactLabel: 'Fragen zu einem Produkt?',
      contactLink: 'Colozoo Support per E-Mail',
    },
  },
  fr: {
    notFound: {
      meta: {
        title: 'Bientôt disponible – Colozoo',
        description:
          'Cette page Colozoo n’est pas encore disponible. Retour à l’accueil ou contact du support.',
      },
      titleLead: 'Cette page',
      titleAccent: 'n’est pas encore prête',
      body1:
        'Merci de visiter Colozoo. Nous préparons encore le contenu de cette page.',
      body2:
        'Retournez à l’accueil ou écrivez-nous si vous avez besoin d’aide avec un produit.',
      goHome: 'Aller à l’accueil',
      askQuestion: 'Nous contacter',
      contactLabel: 'Une question sur un produit ?',
      contactLink: 'Écrire au support Colozoo',
    },
  },
  it: {
    notFound: {
      meta: {
        title: 'In arrivo – Colozoo',
        description:
          'Questa pagina Colozoo non è ancora disponibile. Torna alla home o contatta il supporto.',
      },
      titleLead: 'Questa pagina',
      titleAccent: 'non è ancora pronta',
      body1:
        'Grazie per aver visitato Colozoo. Stiamo ancora preparando i contenuti di questa pagina.',
      body2:
        'Torna alla home o scrivici se hai bisogno di aiuto con un prodotto.',
      goHome: 'Vai alla home',
      askQuestion: 'Contattaci',
      contactLabel: 'Domande su un prodotto?',
      contactLink: 'Scrivi al supporto Colozoo',
    },
  },
  es: {
    notFound: {
      meta: {
        title: 'Próximamente – Colozoo',
        description:
          'Esta página de Colozoo aún no está disponible. Vuelve al inicio o contacta con soporte.',
      },
      titleLead: 'Esta página',
      titleAccent: 'aún no está lista',
      body1:
        'Gracias por visitar Colozoo. Todavía estamos preparando el contenido de esta página.',
      body2:
        'Vuelve a la página principal o escríbenos si necesitas ayuda con un producto.',
      goHome: 'Ir a la página principal',
      askQuestion: 'Contacto',
      contactLabel: '¿Preguntas sobre un producto?',
      contactLink: 'Escribir al soporte de Colozoo',
    },
  },
}
